import { z } from 'zod';

import { CartesianPose, ZERO_POSE } from '@sb/geometry';

export const MountingBracketConfiguration = z.object({
  kind: z.literal('MountingBracket'),
  name: z.string(),
  tcpTransform: CartesianPose.default(ZERO_POSE),
});

export type MountingBracketConfiguration = z.infer<
  typeof MountingBracketConfiguration
>;

export const MountingBracketState = MountingBracketConfiguration;

export type MountingBracketState = z.infer<typeof MountingBracketState>;
